import type { FC } from "react"
import { Button, Icon, Link } from "@chakra-ui/react"

import { EXTERNAL_ROUTES } from "common/constants/routes"
import {
  chainIdToChainReference,
  parseAccountId,
} from "web3/helpers/transformers"
import { Etherscan } from "ui/components/icons/custom/Etherscan"
import ExternalLink from "ui/components/icons/ExternalLink"

type ProposalBlockExplorerURLButtonProps = {
  chainId: string
  txHash: string
}
const ProposalBlockExplorerURLButton: FC<
  ProposalBlockExplorerURLButtonProps
> = ({ chainId, txHash }) => {
  const chainReference = chainIdToChainReference(chainId)

  if (!txHash) {
    return null
  }

  // The txHash is received as AccountId or address format, so the FE needs to handle both cases
  // and convert to an address format to be used in the block explorer URL
  const getCorrectTxHash = (txHash: string) => {
    if (txHash.includes(":")) {
      const { address: _txHash } = parseAccountId(txHash)

      return _txHash
    }

    return txHash
  }

  const correctTxHash = getCorrectTxHash(txHash)

  const blockExplorerUrl = EXTERNAL_ROUTES.etherscan.hash(
    chainReference,
    correctTxHash,
  )

  if (!blockExplorerUrl) {
    return null
  }

  return (
    <Link isExternal className="no-underline" href={blockExplorerUrl}>
      <Button
        leftIcon={<Icon as={Etherscan} />}
        rightIcon={<Icon as={ExternalLink} />}
        size="sm"
        variant="tertiary"
        width="100%"
      >
        View on Block Explorer
      </Button>
    </Link>
  )
}

export default ProposalBlockExplorerURLButton
